import React from 'react';
import AbstractRequestTask from '../AbstractRequestTask';

class PreDownload extends AbstractRequestTask {

  constructor(config, params) {
    super();
    this.params = params;
    this.config = config;
  }

  getUrl() {
    const urlDominioMicrofwk = `${this.config.url_dominio_microfwk}services/cd/add_queue`;
    return urlDominioMicrofwk;
  }

  getParams() {
    //const params = super.getParams(this.config);
    const params = {};
    this.params = Object.assign(params, this.params);
    
    return this.params;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      return this.reject(data, b);
    }
    return this.resolve(data);
  }
}

export default PreDownload;